export default {"src":"/_next/static/media/fire.fdc76cb3.svg","height":16,"width":12,"blurWidth":0,"blurHeight":0};